// Metadata for this Writing, co-located with the demo it describes.
// The Writing list is built by globbing */meta.tsx (see ../registry.ts), so a demo
// appears by existing and disappears by being deleted — no central array to update.
import { Icons } from '#app/components/icons.tsx'

export const demo = {
	title: 'Why editing the books destroys history',
	blurb:
		'Versioning, applied to a ledger. One book keeps every version and can show you any of them; the other keeps one and writes over it.',
	label: 'Demo',
	eyebrow: 'Interactive demo · the immutable book',
	href: '/writing/immutable-ledger',
	listed: true,
	dates: '2026',
	active: true,
	featured: false,
	description:
		'Make the same edits to two journals and watch them diverge. The versioned one appends every change, corrections included, so asking what the book said on a past date is a query against versions that still exist. The other overwrites, so each edit destroys the version a later question would need — and the same question has no answer. Drag the date slider on each: one replays its history, the other sits inert because there is none left.',
	hardProblem:
		'An audit asks what the books said on a date in the past. A ledger you edit in place cannot answer, because each correction destroyed the version the question is about. The folder of copies named v1, v2 and final-FINAL is the workaround, and it is a versioning system nobody designed: which file is authoritative is a matter of memory, two people can edit different copies, and the history it preserves is whatever somebody thought to save.',
	approach:
		'Never overwrite, and versioning follows. Every change is appended, corrections included, so no past state is destroyed and any date is answered by replaying the log up to that point — immutability is the mechanism, being able to ask what the books said is what it buys. The pattern is event sourcing; the two clocks it needs, when a thing happened and when you learned it, are what bitemporal records are for.',
	technologies: [
		'TypeScript',
		'React',
		'Append-only log',
		'Time-travel queries',
	],
	links: [
		{
			type: 'Demo',
			href: '/writing/immutable-ledger',
			icon: <Icons.globe className="size-3" />,
		},
	],
	video: '',
}
